'use client';

import { Trigger } from '@radix-ui/react-popover';
import { FC } from 'react';
import Icon from '../../Icon';

// No mobile este botão é a única porta de entrada para a navegação do site, então
// precisa de nome humano (o antigo title="nav-menu" era um slug de máquina).
const NavbarMenuButton: FC = () => {
	return (
		<Trigger className="md:hidden" aria-label="Abrir menu de navegação">
			<Icon name="menu-burger" className="text-6xl leading-none" />
		</Trigger>
	);
};

export default NavbarMenuButton;
